const GMAIL_KEYS = {
  GMAIL_OPTIONS: 'gmail-options',
  GMAIL_THREADS: 'gmail-threads',
  GMAIL_ATTACHMENT: 'gmail-attachment',
};

const OUTLOOK_KEYS = {
  OUTLOOK_OPTIONS: 'outlook-options',
  OUTLOOK_MESSAGES: 'outlook-messages',
  OUTLOOK_CONVERSATIONS: 'outlook-conversations',
  OUTLOOK_ATTACHMENTS: 'outlook-attachments',
};

export const SMS = 'SMS';

export default {
  ...GMAIL_KEYS,
  ...OUTLOOK_KEYS,
};
